<template>
  <div style="background: #f9f9f9; padding-bottom: 80px" class="adaptiveMobileNewClass">
    <div class="new_top_nap">
      <span>当前位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/supplyHome' }" @click="getNewsItem">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/offlineList' }" @click="getNewsItem" >线下撮合列表</el-breadcrumb-item>
        <el-breadcrumb-item >线下撮合</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="new_con" v-loading="loading">
      <h2>
        {{ newDetail.title }}
      </h2>
      <div class="flex new_con_box">
        <div class="new_con_left flex">
          <p>发布时间：{{ newDetail.createDate }}</p>
        </div>
      </div>
      <div class="new_con_mess editorStyleDetailContent ql-editor vHtmlMess" v-html="newDetail.content"></div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

import {lineCaseDetail} from "../../../../utils/interface";

export default {
  //   新闻
  name: "news",
  components: {},
  data() {
    return {
      loading: false,
      newDetail: {},
      uuid:'',
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  created() {
    this.uuid = this.$route.params.uuid;
    this.getNewsDetail();
  },
  methods: {
    getNewsDetail() {
      this.loading = true
      lineCaseDetail(this.uuid).then((res) => {
        this.loading = false
        this.newDetail = res;
      }).catch(() => {
        this.loading = false
      })
    },

    getNewsItem() {
      this.$router.push({
        name: "offlineList",
      });
    },
  },
};
</script>

<style scoped lang="less">

.blue {
  color: #009999;
}

.red {
  color: #d60000;
}

.soluBanner {
  position: relative;
  width: 100%;

  img {
    width: 100%;
    display: block;
  }

  .soluBanBox {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1200px;
    transform: translate(-50%, -50%);
    color: #fff;

    h2 {
      font-size: 38px;
      letter-spacing: 10px;
    }

    .soluBanText {
      // margin: 8px 0 60px;
      p:nth-child(1) {
        font-size: 17px;
      }

      p:nth-child(2) {
        font-size: 9px;
      }
    }
  }
}

.new_top_nap {
  font-size: 14px;
  color: #808080;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  align-items: center;

  span {
    color: #808080;
  }
}

.new_con {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 80px;
  background: #fff;

  h2 {
    color: #082a48;
    //border-bottom: 1px solid #efefef;
    text-align: center;
    font-size: 26px;
    padding: 15px 0;
  }

  .new_con_box {
    font-size: 13px;
    border-bottom: 1px solid #efefef;
    color: #bbb;
    justify-content: space-between;
    margin: 10px 0;
    padding: 0 40px;

    .new_con_left {
      margin-top: 7px;
      margin-bottom: 10px;

      p {
        margin-right: 25px;
      }

      p:nth-last-child(1) {
        align-items: center;

        i {
          margin-right: 5px;
        }
      }
    }

    .new_con_right {
      align-items: center;
      margin-bottom: 10px;

      p {
        align-items: center;

        i {
          margin-right: 5px;
        }
      }

      .new_icon {
        width: 1px;
        height: 10px;
        background: #efefef;
        margin: 0 15px;
      }
    }
  }

  .new_con_mess {
    margin: 35px 0 20px;
    border-bottom: 1px solid #efefef;
    padding: 0 40px;
    padding-bottom: 20px;
    white-space: pre-wrap;

    p {
      margin-bottom: 20px;
      // text-indent: 2em;
      font-size: 15px;
      line-height: 30px;
      // color: #777;
    }

    /deep/ img {
      max-width: 100% !important;
    }

    // .new_img {
    //     text-align: center;

    //     img {
    //         width: 50%;
    //     }
    // }

    /deep/ span {
      font-size: 15px;
      line-height: 30px;
      // color: #777 ;
    }
  }

  .new_bottom {
    position: relative;
    align-content: center;
    font-size: 14px;
    justify-content: space-between;
    padding: 0 40px;
    padding-bottom: 20px;
    height: 40px;
    cursor: pointer;

    .new_bottom_left {
      color: #082a48;

      p:nth-child(1) {
        align-items: center;

        i {
          width: 5px;
          height: 15px;
          border-radius: 5px;
          background: #082a48;
          margin-right: 6px;
          display: inline-block;
        }
      }

      p:nth-child(2) {
        padding-left: 11px;
        margin-top: 4px;
        width: 88%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .new_bottom_right {
      color: #082a48;
      text-align: right;

      p:nth-child(1) {
        align-items: center;
        i {
          width: 5px;
          height: 15px;
          border-radius: 5px;
          background: #082a48;
          margin-left: 6px;
          display: inline-block;
        }
      }

      p:nth-child(2) {
        padding-left: 11px;
        margin-top: 4px;
        text-align: right;
        position: absolute;
        right: 37px;
        width: 30%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

      }
    }
  }
}

.editorStyleDetailContent {
  /deep/ .video-wrap {
    video {
      width: 100%;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/list/lineDetails.vue